import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from '@angular/router';
import { AppointmentModule } from '../appointment/appointment-route/appointment.module';
import { PatientModule } from '../patient/patient-module/patient.module';
import { UserModule } from '../user/user-module/user.module';
import { MasterModule } from '../master/master.module';
import { ReportModule } from '../report/report.module';
import { AuthorizeUserService } from '../../component/shared/authorize-user.service';
import { NotAuthorizedComponent } from '../../component/not-authorized/not-authorized.component';
import { DashboardComponent } from '../../component/dashboard/dashboard.component';
import {CalendarComponent} from '../appointment/calendar/calendar.component';
import {PromoCodeModule} from '../promocode/promocode.module';
import {VideoModule} from '../video/video.module';
import { EventPipe } from '../appointment/calendar/event.pipe';
import { ShowTaskComponent } from '../appointment/calendar/show-task.component';
import { UtilityService } from '../appointment/calendar/utility.service';
import { ShowTaskListComponent } from '../appointment/calendar/show-task-list.component';
export function routeAppdata() {
  return AppointmentModule;
}
export function routeUsrdata() {
  return UserModule;
}
export function routePatdata() {
  return PatientModule;
}
export function routeMstdata() {
  return MasterModule;
}
export function routeRptdata() {
  return ReportModule;
}
export function routePrcdata() {
  return PromoCodeModule;
}

export function routeVddata() {
  return VideoModule;
}

const routes: Routes = [
  {path : '', redirectTo : 'dashboard'},
  {path : 'dashboard', component : DashboardComponent},
  {path : 'notauthorized', component : NotAuthorizedComponent},
  {path : 'appointment', loadChildren:routeAppdata , data : {allowedModule : 'APPOINTMENT'} ,canActivate:[AuthorizeUserService]},
  {path : 'user', loadChildren:routeUsrdata , data : {allowedModule : 'USER'} ,canActivate:[AuthorizeUserService]},
  {path : 'patient', loadChildren: routePatdata , data : {allowedModule : 'PATIENT'} ,canActivate:[AuthorizeUserService]},
  {path : 'master', loadChildren:routeMstdata , data : {allowedModule : 'MASTER'} ,canActivate:[AuthorizeUserService]},
  {path : 'report', loadChildren:routeRptdata , data : {allowedModule : 'REPORT'} ,canActivate:[AuthorizeUserService]},
  {path : 'promocode', loadChildren:routePrcdata , data : {allowedModule : 'PROMOCODE'} ,canActivate:[AuthorizeUserService]},
  {path : 'video', loadChildren:routeVddata , data : {allowedModule : 'VIDEOCONFERENCE'} ,canActivate:[AuthorizeUserService]}
];

@NgModule({
  imports: [RouterModule.forChild(routes),CommonModule],
  providers:[AuthorizeUserService, UtilityService],
  exports: [RouterModule],
  declarations: [NotAuthorizedComponent, DashboardComponent, CalendarComponent, EventPipe, ShowTaskComponent, ShowTaskListComponent] 
})
export class MainRoutingModule { };


// WEBPACK FOOTER //
// ./src/app/section/main/main-route.module.ts